/**
 * Web Root Component
 * Can include web-specific imports
 */
import React from 'react';
import { View, StatusBar } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
// Use the same AuthContext used by tabs and screens
import { AuthProvider } from '../src/context/AuthContext';
import WebNavigator from './WebNavigator'; // Web-specific navigation

const WebApp = () => {
  return (
    <SafeAreaProvider>
      <GestureHandlerRootView style={{ flex: 1 }}>
        <StatusBar />
        <AuthProvider>
          <NavigationContainer>
            <View style={{ flex: 1, minHeight: '100vh', backgroundColor: '#F5F4F0', alignItems: 'center' }}>
              <View style={{ flex: 1, width: '100%', maxWidth: 1024, backgroundColor: '#FFFFFF' }}>
                <WebNavigator />
              </View>
            </View>
          </NavigationContainer>
        </AuthProvider>
      </GestureHandlerRootView>
    </SafeAreaProvider>
  );
};

export default WebApp;